import { jsxs, jsx } from "react/jsx-runtime";
const IconHome2Svg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M13.94 5.833 7.94.5a.667.667 0 0 0-.88 0l-6 5.333A.667.667 0 0 0 1.5 7h.667v6a.667.667 0 0 0 .666.667h9.334a.667.667 0 0 0 .666-.667V7h.667a.667.667 0 0 0 .44-1.167Zm-5.773 6.5H6.833v-2a.667.667 0 0 1 1.334 0v2Zm3.333 0h-2v-2a2 2 0 1 0-4 0v2h-2V7h8v5.333ZM3.253 5.667 7.5 1.893l4.247 3.774H3.253Z" })
    ]
  }
);
export {
  IconHome2Svg
};
